export default __webpack_public_path__ + "static/media/time.c31f8723.svg";